export default __webpack_public_path__ + "static/media/JUICE.2c067a1a.svg";